import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/gcstaff/aiassistant/LibraroPage.css";

const BOT_AVATAR = (
  <div className="gcteacher-sl-avatar gcteacher-sl-avatar-bot">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
      <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25.286 25.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.134Z"/>
      <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"/>
    </svg>
  </div>
);

const USER_AVATAR = (
  <div className="gcteacher-sl-avatar gcteacher-sl-avatar-user">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.029 10 8 10c-2.029 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
    </svg>
  </div>
);

const INITIAL_MESSAGES = [{ id: 1, role: "bot", content: null, isWelcome: true }];

const formatMessage = (text) => {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**"))
      return <strong key={i}>{part.slice(2, -2)}</strong>;

    if (part.includes("\n•")) {
      return part.split("\n").map((line, j) =>
        line.startsWith("•")
          ? <span key={j} className="gcteacher-sl-bullet">{line}</span>
          : line ? <span key={j}>{line}</span> : null
      );
    }
    return <span key={i}>{part}</span>;
  });
};

const WelcomeMessage = () => (
  <div className="gcteacher-sl-welcome-content">
    <p className="gcteacher-sl-welcome-intro">
      Hello! I'm <strong>SmartLib AI</strong>, your AI library assistant. I can help you:
    </p>
    <ul className="gcteacher-sl-welcome-list">
      <li><span className="gcteacher-sl-welcome-icon">📚</span> Recommend books from our library</li>
      <li><span className="gcteacher-sl-welcome-icon">🖥️</span> Create presentation outlines</li>
      <li><span className="gcteacher-sl-welcome-icon">🗂️</span> Summarize notes/PDFs &amp; create flash cards</li>
    </ul>
    <p className="gcteacher-sl-welcome-footer">How can I help you today?</p>
  </div>
);

const TypingIndicator = () => (
  <div className="gcteacher-sl-typing">
    <span/><span/><span/>
  </div>
);

const FlashCardIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2"/>
    <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
    <line x1="12" y1="12" x2="12" y2="16"/>
    <line x1="10" y1="14" x2="14" y2="14"/>
  </svg>
);

const PaperclipIcon = () => (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
    <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
  </svg>
);

/* ══════════════════════════════════════
   SmartLib AI Page (Teacher)
══════════════════════════════════════ */
const LibraroPage = () => {

  const { baseUrl, authToken, loggedInUser } = useContext(AppContext);

  const [messages, setMessages] = useState(INITIAL_MESSAGES);
  const [inputValue, setInputValue] = useState("");
  const [isTyping, setIsTyping]    = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [savingId, setSavingId]    = useState(null);
  const [savedIds, setSavedIds]    = useState(new Set());

  const messagesEndRef = useRef(null);
  const inputRef       = useRef(null);
  const fileInputRef   = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isTyping]);

  /* Build conversation history for the API — role "bot" -> "assistant",
     skip the welcome message, only keep text-based turns. */
  const buildHistoryPayload = (allMessages) => {
    return allMessages
      .filter(m => !m.isWelcome && typeof m.content === "string")
      .map(m => ({
        role: m.role === "user" ? "user" : "assistant",
        content: m.content,
      }));
  };

  const handleSend = () => {
    const text = inputValue.trim();
    if (!text || isTyping) return;

    const userMsg = { id: Date.now(), role: "user", content: text };
    const updatedMessages = [...messages, userMsg];

    setMessages(updatedMessages);
    setInputValue("");
    setIsTyping(true);

    axios
      .post(
        `${baseUrl}/teacher/smartlib-ai/chat`,
        { messages: buildHistoryPayload(updatedMessages) },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        const reply =
          res.data?.success && res.data?.reply
            ? res.data.reply
            : res.data?.message || "Sorry, SmartLib AI could not process that.";

        setMessages((prev) => [
          ...prev,
          { id: Date.now() + 1, role: "bot", content: reply, sourcePrompt: text },
        ]);
      })
      .catch((error) => {
        console.error("SmartLib AI error:", error);
        setMessages((prev) => [
          ...prev,
          {
            id: Date.now() + 1,
            role: "bot",
            content: "⚠️ SmartLib AI is currently unavailable. Please try again in a moment.",
            sourcePrompt: text,
          },
        ]);
      })
      .finally(() => {
        setIsTyping(false);
        inputRef.current?.focus();
      });
  };

  /* ── Actual file upload — sends the file to the backend for parsing + summary ── */
  const handleFileSelected = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const userMsg = { id: Date.now(), role: "user", content: `📄 Uploaded: ${file.name}` };
    setMessages(prev => [...prev, userMsg]);
    setIsUploading(true);
    setIsTyping(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("prompt", "Summarize this document");

    axios
      .post(`${baseUrl}/teacher/smartlib-ai/upload-file`, formData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const reply =
          res.data?.success && res.data?.reply
            ? res.data.reply
            : res.data?.message || "Could not summarize this file.";

        setMessages((prev) => [
          ...prev,
          { id: Date.now() + 1, role: "bot", content: reply, sourcePrompt: `Summary of ${file.name}` },
        ]);
      })
      .catch((error) => {
        console.error("SmartLib AI file upload error:", error);
        setMessages((prev) => [
          ...prev,
          { id: Date.now() + 1, role: "bot", content: "⚠️ Could not read or summarize this file. Please try another one." },
        ]);
      })
      .finally(() => {
        setIsUploading(false);
        setIsTyping(false);
        if (fileInputRef.current) fileInputRef.current.value = "";
      });
  };

  /* ── Generate + Save Flash Card — condenses the AI reply into bullet points first ── */
  const handleGenerateFlashCard = (msg) => {
    if (!loggedInUser?.id || savingId === msg.id) return;

    setSavingId(msg.id);

    const title = (msg.sourcePrompt || "Flash Card")
      .replace(/\*\*/g, "")
      .trim()
      .substring(0, 80);

    axios
      .post(
        `${baseUrl}/teacher/smartlib-ai/flashcard-points`,
        { content: msg.content },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((pointsRes) => {
        const points = pointsRes.data?.success
          ? pointsRes.data.points
          : msg.content;

        const formData = new FormData();
        formData.append("lbteacher_id", loggedInUser.id);
        formData.append("title",        title);
        formData.append("subtitle",     "Generated from AI Chat");
        formData.append("type",         "AI Chat");
        formData.append("descryption",  points);

        return axios.post(`${baseUrl}/teacher/flashcards/storeFlashCard`, formData, {
          headers: {
            Authorization:  `Bearer ${authToken}`,
            "Content-Type": "multipart/form-data",
          },
        });
      })
      .then((res) => {
        if (res.data.success) {
          setSavedIds(prev => new Set([...prev, msg.id]));
        }
      })
      .catch((err) => {
        console.log("Failed to save flash card:", err);
      })
      .finally(() => {
        setSavingId(null);
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSend(); }
  };

  const handleQuickAction = (action) => {
    if (action === "upload") {
      fileInputRef.current?.click();
      return;
    }
    const actionMap = {
      recommend: "Recommend me some books from the library",
      outline: "Help me create a presentation outline",
    };
    setInputValue(actionMap[action] || "");
    inputRef.current?.focus();
  };

  return (
    <Container fluid className="gcteacher-sl-wrapper">
      <Row className="h-100">
        <Col xs={12} className="gcteacher-sl-col">

          {/* Header */}
          <div className="gcteacher-sl-header">
            <div className="gcteacher-sl-header-left">
              <div className="gcteacher-sl-header-avatar">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"/>
                </svg>
              </div>
              <div>
                <h5 className="gcteacher-sl-title">SmartLib AI</h5>
                <span className="gcteacher-sl-subtitle">
                  AI Library Assistant — Recommend Books, Create Presentations &amp; Flash Cards
                </span>
              </div>
            </div>
          </div>

          {/* Chat Body */}
          <div className="gcteacher-sl-chat-body">
            {messages.map((msg, index) => (
              <div
                key={msg.id}
                className={`gcteacher-sl-message-row ${msg.role === "user" ? "gcteacher-sl-row-user" : "gcteacher-sl-row-bot"}`}
                style={{ animationDelay: `${index * 0.04}s` }}
              >
                {msg.role === "bot" && BOT_AVATAR}

                <div className="gcteacher-sl-bubble-group">
                  <div className={`gcteacher-sl-bubble ${msg.role === "user" ? "gcteacher-sl-bubble-user" : "gcteacher-sl-bubble-bot"}`}>
                    {msg.isWelcome ? (
                      <WelcomeMessage />
                    ) : (
                      <div className="gcteacher-sl-bubble-text">
                        {msg.content && msg.content.split("\n").map((line, i) => {
                          if (!line) return <br key={i} />;
                          if (line.startsWith("•"))
                            return <div key={i} className="gcteacher-sl-bullet-line">{formatMessage(line)}</div>;
                          return <p key={i}>{formatMessage(line)}</p>;
                        })}
                      </div>
                    )}
                  </div>

                  {msg.role === "bot" && !msg.isWelcome && (
                    <button
                      className={`gcteacher-sl-fc-btn ${savedIds.has(msg.id) ? "gcteacher-sl-fc-btn--saved" : ""}`}
                      onClick={() => handleGenerateFlashCard(msg)}
                      disabled={savingId === msg.id || savedIds.has(msg.id)}
                      title={savedIds.has(msg.id) ? "Flash card saved!" : "Save as Flash Card"}
                    >
                      <FlashCardIcon />
                      {savingId === msg.id
                        ? "Saving..."
                        : savedIds.has(msg.id)
                        ? "✓ Flash Card Saved"
                        : "Generate Flash Card"}
                    </button>
                  )}
                </div>

                {msg.role === "user" && USER_AVATAR}
              </div>
            ))}

            {isTyping && (
              <div className="gcteacher-sl-message-row gcteacher-sl-row-bot gcteacher-sl-anim-in">
                {BOT_AVATAR}
                <div className="gcteacher-sl-bubble gcteacher-sl-bubble-bot gcteacher-sl-bubble-typing">
                  <TypingIndicator />
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Quick Actions */}
          <div className="gcteacher-sl-quick-actions">
            <button className="gcteacher-sl-quick-btn" onClick={() => handleQuickAction("recommend")}>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
                <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.746c-.917-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.649.655 4.12.75a13.85 13.85 0 0 0-3.659.879A.5.5 0 0 0 0 2.009v9.5a.5.5 0 0 0 .645.480c.876-.329 2.018-.636 3.145-.75 1.034-.105 2.026.008 2.71.562v-.003c.353.093.723.14 1.1.14.378 0 .747-.047 1.1-.14v.003c.684-.554 1.676-.667 2.71-.563 1.127.115 2.27.421 3.145.75A.5.5 0 0 0 16 11.51v-9.5a.5.5 0 0 0-.461-.495 13.85 13.85 0 0 0-3.659-.878C10.35.655 8.985.936 8 1.783z"/>
              </svg>
              Recommend Books
            </button>
            <button className="gcteacher-sl-quick-btn" onClick={() => handleQuickAction("outline")}>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-4l.245 1.468a.5.5 0 0 1-.686.56l-3.5-1.75L4.5 15.5H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2.5a.5.5 0 0 1 .5.5v1l2.5-1.5a.5.5 0 0 1 .5 0L11 14v-1a.5.5 0 0 1 .5-.5H14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2z"/>
              </svg>
              Create Presentation Outline
            </button>
            <button className="gcteacher-sl-quick-btn" onClick={() => handleQuickAction("upload")} disabled={isUploading}>
              <PaperclipIcon />
              {isUploading ? "Uploading..." : "Summarize a PDF"}
            </button>
          </div>

          {/* Hidden file input — triggered by the Summarize a PDF quick action */}
          <input
            type="file"
            ref={fileInputRef}
            accept=".pdf,.txt"
            style={{ display: "none" }}
            onChange={handleFileSelected}
          />

          {/* Input Bar */}
          <div className="gcteacher-sl-input-bar">
            <input
              ref={inputRef}
              type="text"
              className="gcteacher-sl-input"
              placeholder="Ask SmartLib AI anything about books, presentations, or notes..."
              value={inputValue}
              onChange={e => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              disabled={isTyping}
            />
            <button
              className={`gcteacher-sl-send-btn ${inputValue.trim() ? "gcteacher-sl-send-active" : ""}`}
              onClick={handleSend}
              disabled={!inputValue.trim() || isTyping}
              aria-label="Send message"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"/>
              </svg>
            </button>
          </div>

        </Col>
      </Row>
    </Container>
  );
};

export default LibraroPage;